import React from 'react'
import './stylespin.css'
const Spinner=(props)=> {
  return (
    <>
    <div className="lds-circle"><div></div></div>
    
    </>
  )
}

export default Spinner
